import actionTypes from "../constants/actionTypes";

const initialState = {
  isLogin: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOGIN:
      return {
        ...state,
        isLogin: true,
      };
    case actionTypes.LOGOUT:
      return {
        ...state,
        isLogin: false,
      };
    default:
      return state;
  }
}
